import { db } from '@/config'
import { parseDocument } from '@/utils'
import getRandomSimilars from '@/utils/randomSimilars'

export default {
  state: {
    program: null,
    programs: null,
    videoBack: null
  },
  mutations: {
    setProgram (state, payload) {
      state.program = payload
    },
    setPrograms (state, payload) {
      state.programs = payload
    },
    setVideoBack (state, payload) {
      this.videoBack = payload
    },
    setProgramSimilars (state) {
      (state.programs || []).map(i => {
        i.similars = null
      })
    }
  },
  actions: {
    async getProgram ({ commit, dispatch, state }, id) {
      const myList = state.myList || []
      const programs = await dispatch('getShadowPrograms')
      return db.collection('programs').doc(id).onSnapshot(async (doc) => {
        const data = { id: doc.id, ...doc.data() }
        console.log(data.video_ref)
        if (data.video_ref && data.video_ref.status) {
          data.video = data.video_ref
        } else if (data.video_ref) {
          let video = (await data.video_ref.get()).data()
          data.video = video
        }
        data.inList = !!myList.find(i => i.id === data.id)
        if (!data.similars) {
          data.similars = getRandomSimilars(programs)
        }
        if (data.similars && data.similars.length) {
          const promises = data.similars.map(async (s) => {
            return parseDocument(await s.get())
          })
          data.similars = await Promise.all(promises)
        }
        commit('setProgram', data)
        return data
      })
    },
    async getProgramBySlug ({ commit, dispatch, state }, slug) {
      const myList = state.myList || []
      const programs = await dispatch('getShadowPrograms')
      return db.collection('programs').where('slug', '==', slug).onSnapshot(async (snap) => {
        const doc = snap.docs[0]
        const data = { id: doc.id, ...doc.data() }
        console.log(data.video_ref)
        if (data.video_ref && data.video_ref.status) {
          data.video = data.video_ref
        } else if (data.video_ref) {
          let video = (await data.video_ref.get()).data()
          data.video = video
          if (video && video.live) {
            data.live = video.live
          }
        }
        data.inList = !!myList.find(i => i.id === data.id)
        console.log('similars', data.similars, data.slug, programs.map(i => i.slug))
        if (!data.similars) {
          data.similars = getRandomSimilars(programs)
        }
        if (data.similars && data.similars.length) {
          const promises = data.similars.map(async (s) => {
            return parseDocument(await s.get())
          })
          data.similars = (await Promise.all(promises)).filter(i => i.slug !== data.slug)
        }
        commit('setProgram', data)
        return data
      })
    },
    async getShadowProgram ({ commit, dispatch, getters }, id) {
      let tags = getters.tags
      if (!(tags && tags.length)) {
        tags = await dispatch('getTagsOnce')
      }
      let found = null
      console.log('TAGS', {tags})
      if (tags && tags.length) {
        tags.find(tag => {
          found = (tag.programs || []).find(program => program.id === id)
          return found
        })
      }
      commit('setProgram', found)
    },
    async getPrograms ({ commit, state }) {
      return db.collection('programs').onSnapshot(async (snap) => {
        const list = snap.docs.map(doc => {
          return { id: doc.id, ...doc.data() }
        })
        commit('setPrograms', list)
        return list
      })
    },
    async getShadowPrograms ({ commit, dispatch, getters }) {
      let tags = getters.tags
      if (!(tags && tags.length)) {
        tags = await dispatch('getTagsOnce')
      }
      let list = []
      if (tags && tags.length) {
        tags.map(tag => {
          list.push(...(tag.programs || []))
        })
      }
      commit('setPrograms', list)
      return list
    }
  },
  getters: {
    program: (state) => state.program,
    programs: (state) => state.programs,
    videoBack: (state) => state.videoBack
  }
}
